import '../../css/App.css'
import '../../css/ToolTip.css'
import '../../css/FormTemplate.css'
import '../../css/AddAssetForm.css'
import axios from 'axios';
import React, {useContext, useState} from 'react'
import {IAddAssetForm, IAddAssetFormValidation, IAuth, IConfiguration} from '../../interfaces/interface'
import {IMessageSender, IMessageErrorResponse} from '../../interfaces/messageInterface';
import {AddAssetContext} from '../context/AddAssetContext';
import {AppContext} from '../context/AppContext';
import FormInternalDivTemplate from '../formTemplate/FormInternalDivTemplate';
import FormSubmitButton from '../formTemplate/FormSubmitButton';
import FormErrorDivTemplate from '../formTemplate/FormErrorDivTemplate';
import FormNewTypeSelectInputDivTemplate from '../formTemplate/FormNewTypeSelectInputDivTemplate';
import FormSelectInternalDivTemplate from '../formTemplate/FormSelectInternalDivTemplate';

const AddAssetForm = () => {
    const {aAForm, formVal, defaultValueSelect, valueSelect, errMessage} = useContext(AddAssetContext);
    const {navBarStatus, config, authorization, disMessage, errorHandlerFunction} = useContext(AppContext);
    const [isNavbarOpen] = navBarStatus;
    const [configuration]: IConfiguration[] = config
    const [, setConfiguration]: React.Dispatch<React.SetStateAction<IConfiguration>>[] = config
    const [auth]: IAuth[] = authorization;
    const [formInput]: IAddAssetForm[] = aAForm;
    const [, setFormInput]: React.Dispatch<React.SetStateAction<IAddAssetForm>>[] = aAForm;
    const [displayMessage]: string[] = disMessage;
    const [, setDisplayMessage]: React.Dispatch<React.SetStateAction<string>>[] = disMessage;
    const [formFieldsValid]: IAddAssetFormValidation[] = formVal;
    const [, setFormFieldsValid]: React.Dispatch<React.SetStateAction<IAddAssetFormValidation>>[] = formVal;
    const [deviceIdArr, setDeviceIdArr] = useState<string[]>([]);
    const [addNewType, setAddNewType] = useState<boolean>(false);
    const [defaultSelectValue, setDefaultSelectValue] = defaultValueSelect;
    const [selectValue, setSelectValue] = valueSelect;
    const [, setErrorMessage]: React.Dispatch<React.SetStateAction<string>>[] = errMessage;
    const errorHandler: (status: number) => string = errorHandlerFunction;

    const deviceIdChangeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        let input = e.target.value.toUpperCase();
        if (/^[0-9a-fA-F]+$/.test(input) || input === "") {
            setFormInput({
                ...formInput,
                deviceId: input
            })
            if (input.length >= 3) {
                let messageBody: IMessageSender = {
                    type: 'getDeviceIDs',
                    userId: auth.username,
                    deviceIdFilter: {
                        Type: "Unassigned Trackers",
                        Pattern: input,
                    }
                }
                /*axios.post('/message',messageBody *//*For Cookie*/
                axios.post('/message', messageBody, auth.header
                ).then(res => {
                    if (res.data.status === "OK") {
                        setDeviceIdArr(res.data.names)
                        setFormFieldsValid({
                            ...formFieldsValid,
                            deviceId: {
                                ...formFieldsValid.deviceId,
                                displayMessage: false,
                                message: ""
                            }
                        })
                        if (res.data.names.includes(input)) {
                            setFormFieldsValid({
                                ...formFieldsValid,
                                deviceId: {
                                    isValid: true,
                                    displayMessage: false,
                                    message: ""
                                }
                            })
                        } else {
                            setFormFieldsValid({
                                ...formFieldsValid,
                                deviceId: {
                                    ...formFieldsValid.deviceId,
                                    isValid: false,
                                }
                            })
                        }
                    } else {
                        setDeviceIdArr([])
                        setFormFieldsValid({
                            ...formFieldsValid,
                            deviceId: {
                                isValid: false,
                                displayMessage: true,
                                message: res.data.errorDescription
                            }
                        })
                    }
                }).catch(({response}: IMessageErrorResponse) => {
                    const errorMessage = errorHandler(response.data.status)
                    setErrorMessage(errorMessage)
                    setDisplayMessage("error");
                })
            } else {
                setDeviceIdArr([])
                setFormFieldsValid({
                    ...formFieldsValid,
                    deviceId: {
                        ...formFieldsValid.deviceId,
                        isValid: false,
                    }
                })
            }
        }
    }
    const changeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        let input = e.target.value;
        if (!(/'/.test(input)) && !(/"/.test(input)) && !(/`/.test(input))) {
            setFormInput({
                ...formInput,
                [e.target.name]: input,
            });
            if (e.target.name === "assetType") {
                if (e.target.value !== "") {
                    setFormFieldsValid({
                        ...formFieldsValid,
                        assetType: {
                            isValid: true,
                            displayMessage: false,
                            message: ""
                        }
                    })
                }
            }
            if (e.target.name === "assetName") {
                setFormFieldsValid({
                    ...formFieldsValid,
                    assetName: {
                        isValid: false,
                        displayMessage: false,
                        message: ""
                    }
                })
            }
        }
    };
    const newTypeChangeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        let input = e.target.value;
        if (!(/'/.test(input)) && !(/"/.test(input)) && !(/`/.test(input))) {
            setSelectValue(input);
        }
    };
    const selectChangeHandler = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        if (e.target.value === "addNewType") {
            setAddNewType(true);
            setFormInput({
                ...formInput,
                assetType: ""
            });
        } else {
            setFormInput({
                ...formInput,
                assetType: e.target.value,
            });
            if (e.target.value !== "") {
                setFormFieldsValid({
                    ...formFieldsValid,
                    assetType: {
                        isValid: true,
                        displayMessage: false,
                        message: ""
                    }
                })
            }
        }
    };
    const blurHandler = (e: React.FocusEvent<HTMLInputElement, Element>): void => {
        if (e.target.value !== "") {
            let messageBody: IMessageSender = {
                type: 'getAssetInfo',
                userId: auth.username,
                assetInfo: formInput
            }
            try {

                axios.post('/message', messageBody, auth.header
                ).then(res => {
                    if (res.data.status === "OK") {
                        setFormFieldsValid({
                            ...formFieldsValid,
                            assetName: {
                                isValid: false,
                                displayMessage: true,
                                message: "Asset already exists"
                            }
                        })
                    } else {
                        setFormFieldsValid({
                            ...formFieldsValid,
                            assetName: {
                                isValid: true,
                                displayMessage: false,
                                message: ""
                            }
                        })
                    }
                }).catch(({response}: IMessageErrorResponse) => {
                    const errorMessage = errorHandler(response.data.status)
                    setErrorMessage(errorMessage)
                    setDisplayMessage("error");
                })
            } catch {

                throw new Error("The server is unavailable at this moment. please try again later...");
            }
        }
    }
    const typeBlurHandler = (e: React.FocusEvent<HTMLInputElement, Element>) => {
        let newType = e.target.value;
        if (newType !== "") {
            if (!configuration.assetTypes.includes(newType)) {
                let tempAssetTypes = configuration.assetTypes;
                tempAssetTypes.push(newType);
                setConfiguration({
                    ...configuration,
                    assetTypes: [...tempAssetTypes]
                });

            }
            setDefaultSelectValue(newType)
            setFormInput({
                ...formInput,
                assetType: newType,
            });
            setSelectValue("");
            setFormFieldsValid({
                ...formFieldsValid,
                assetType: {
                    isValid: true,
                    displayMessage: false,
                    message: ""
                }
            })
        }
        setAddNewType(false);
    }
    const submitHandler = (e: React.FormEvent<HTMLFormElement>, isReCheck: boolean) => {
        e.preventDefault();
        console.log(formInput);

        if (formValidation(e, isReCheck)) {
            setDisplayMessage("asset-details");
        }
    }
    const assetNameReCheck = (e: React.FormEvent<HTMLFormElement>) => {
        let messageBody: IMessageSender = {
            type: 'getAssetInfo',
            userId: auth.username,
            assetInfo: formInput
        }
        axios.post('/message', messageBody, auth.header
        ).then(res => {
            if (res.data.status !== "OK") {
                setFormFieldsValid({
                    ...formFieldsValid,
                    assetName: {
                        isValid: true,
                        displayMessage: false,
                        message: ""
                    }
                })
                submitHandler(e, true);
            }
        }).catch(({response}: IMessageErrorResponse) => {
            const errorMessage = errorHandler(response.data.status)
            setErrorMessage(errorMessage)
            setDisplayMessage("error");
        })
    }
    const formValidation = (e: React.FormEvent<HTMLFormElement>, isReCheck: boolean): boolean => {
        let isFormValid = true
        let tempFormFieldsValid = formFieldsValid
        Object.entries(formInput).forEach(([key, value]) => {
            if (key === "assetName" || key === "deviceId" || key === "assetType") {
                if (value === "") {
                    tempFormFieldsValid[key] = {
                        isValid: false,
                        displayMessage: true,
                        message: "Field cannot be empty"
                    }
                    isFormValid = false
                }
            }
        })
        setFormFieldsValid({...tempFormFieldsValid})
        Object.entries(formFieldsValid).forEach(([key, value]) => {
            if (key === "deviceId" || key === "assetType") {
                if (!value.isValid) {
                    isFormValid = false
                }
            }
        })
        if (isFormValid && !formFieldsValid.assetName.isValid) {
            isFormValid = false;
            if (!isReCheck) {
                assetNameReCheck(e)
            }
        }
        return isFormValid;
    }
    const isDisabled = (): boolean => {
        return displayMessage !== "none" || isNavbarOpen === true;
    }
    const profileStateChangeHandler = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        setFormInput({
            ...formInput,
            [e.target.name]: e.target.value,
        })
        if (e.target.name === "state" && e.target.value === "Sleep") {
            setDisplayMessage("warning")
        }
    }
    return (
        <form className="form-template" onSubmit={(e) => submitHandler(e, false)}>
            <div className='form-template-top-container'>
                < FormInternalDivTemplate
                    id="deviceId"
                    label="Tracker ID *"
                    listId="trackersId"
                    type="list"
                    array={deviceIdArr}
                    value={formInput.deviceId}
                    maxLength={8}
                    displayMessage={formFieldsValid.deviceId.displayMessage}
                    message={formFieldsValid.deviceId.message}
                    onChange={deviceIdChangeHandler}
                    disabled={isDisabled()}
                />
                < FormInternalDivTemplate
                    id="assetName"
                    label="Asset name *"
                    type="text"
                    value={formInput.assetName}
                    maxLength={32}
                    displayMessage={formFieldsValid.assetName.displayMessage}
                    message={formFieldsValid.assetName.message}
                    onChange={changeHandler}
                    onBlur={blurHandler}
                    disabled={isDisabled()}
                    dataToolTip="Asset name must be unique"
                    placeHolder='Type...'
                    checkSign={formFieldsValid.assetName.isValid}
                />


                <div className={addNewType ? "form-template-internal-div error-space" : "form-template-internal-div"}>
                    <label htmlFor="assetType" className="form-template-label">Asset Type *</label>
                    {
                        !addNewType ?
                            <>
                                <FormNewTypeSelectInputDivTemplate
                                    id="assetType"
                                    selectChangeHandler={selectChangeHandler}
                                    disabled={isDisabled()}
                                    optionList={configuration?.assetTypes}
                                    defaultSelectValue={defaultSelectValue}
                                />
                                <FormErrorDivTemplate displayMessage={formFieldsValid.assetType.displayMessage}
                                                      message={formFieldsValid.assetType.message}/>
                            </>
                            :
                            <div className='form-template-input-div-without-icon'>
                                <input
                                    name="assetTypeInput"
                                    id="assetTypeInput"
                                    className="form-template-input"
                                    onChange={newTypeChangeHandler}
                                    value={selectValue}
                                    placeholder='Please enter new Type'
                                    maxLength={24}
                                    disabled={isDisabled()}
                                    onBlur={typeBlurHandler}
                                />
                            </div>
                    }
                </div>
                < FormInternalDivTemplate
                    id="assetDescription"
                    label="Description"
                    type="text"
                    value={formInput.assetDescription}
                    maxLength={64}
                    onChange={changeHandler}
                    disabled={isDisabled()}
                    dataToolTip="Optional. Additional info on your asset, like customer name"
                    placeHolder='Type...'
                    errorSpace={true}
                />
                {
                    configuration.profiles &&
                    <FormSelectInternalDivTemplate
                        id="profile"
                        label="Profile"
                        disabled={isDisabled()}
                        selectChangeHandler={profileStateChangeHandler}
                        optionList={configuration.profiles}
                        errorSpace={true}
                        placeHolder='Pleas choose profile...'
                        dataToolTip="Device configuration Profile"

                    />
                }
                {
                    (configuration.profiles && configuration.states) &&
                    <FormSelectInternalDivTemplate
                        id="state"
                        label="State"
                        disabled={isDisabled()}
                        selectChangeHandler={profileStateChangeHandler}
                        optionList={configuration.states}
                        errorSpace={true}
                        placeHolder="Pleas choose state..."
                        dataToolTip="Device state: Operational (default), Sleep, etc."

                    />
                }
            </div>
            <FormSubmitButton text="Activate" disabled={isDisabled()}/>
        </form>
    );
};

export default AddAssetForm;